import { useEffect, useRef } from "react";
import SiriWaveLib from "siriwave";

interface SiriWaveProps {
  isActive: boolean;
  theme?: "light" | "dark";
}

export function SiriWave({ isActive, theme = "light" }: SiriWaveProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  const waveRef = useRef<any>(null);

  useEffect(() => {
    if (containerRef.current && !waveRef.current) {
      waveRef.current = new SiriWaveLib({
        container: containerRef.current,
        style: "ios9",
        width: 440,
        height: 140,
        autostart: true,
        speed: 0.1,
        amplitude: isActive ? 1 : 0.3,
        frequency: 4,
        color: theme === "dark" ? "#fff" : "#000",
      });
    }

    return () => {
      if (waveRef.current) {
        waveRef.current.dispose();
        waveRef.current = null;
      }
    };
  }, []);

  useEffect(() => {
    if (waveRef.current) {
      waveRef.current.setAmplitude(isActive ? 1 : 0.1);
    }
  }, [isActive]);

  return <div ref={containerRef} className="w-full" />;
}